{
	"AgentAdvanced_Fields_LicenceType": "Call Center License Type:",
	"AgentAdvanced_Fields_InternalNumber": "Internal Number:",
	"AgentAdvanced_Fields_CiscoCommonID": "Cisco Common Identity:",
	"AgentAdvanced_Fields_OverrideMonitoring": "Override Monitoring:",
	"AgentAdvanced_Fields_WebexCallingUserID": "Webex Calling User ID:",
	"AgentAdvanced_Fields_BroadworksUserID": "BroadWorks User ID:",
	"AgentAdvanced_Fields_TeamsUserID": "MS Teams User ID:",
	"AgentAdvanced_Fields_UserPrincipalName": "User Principal Name (URN):",
	"AgentAdvanced_Fields_OwningGroupID": "Owning Group ID:",
	"AgentAdvanced_Fields_OIDOnTelephoneServer": "OID on Telephone Server:",
	"AgentAdvanced_Fields_OwningDepartment": "Owning Department (Full Path):",
	"CallCentreLicenceTypes_None": "[None]",
	"CallCentreLicenceTypes_Basic": "Basic",
	"CallCentreLicenceTypes_Standard": "Standard",
	"CallCentreLicenceTypes_Premium": "Premium",
	"NAME": "AgentAdvanced"
}